import Icon from 'veui/components/Icon'
import { IconThumbUp } from 'dls-icons-vue'

Icon.register('thumb-up', IconThumbUp)
